import { ManageClaimsOld } from "../../components/MeritCS/ManageClaimsOld";
import React from "react";

// Shall be deprecated once ManageClaims screen is implemented as part of GS-1981
export const ManageClaimsOldScreen = () => <ManageClaimsOld />;
